import React, { useEffect } from "react";
import "./styles.css";
import Cookies from "js-cookie";

const RefundTable = ({
  setBankDetails,
  billData,
  items,
  setItems,
  totalRefundAmount,
}) => {
  const ssp_role = Cookies.get("ssp_role");

  useEffect(() => {
    if (billData && billData.length > 0) {
      setItems(
        billData.map((item) => ({
          ...item,
          refund_qty: 0,
          refund_amount: 0,
          reason: "",
        }))
      );
    }
  }, [billData]);

  const handleRefundQtyChange = (index, value) => {
    const updatedItems = [...items];
    const item = updatedItems[index];

    // Always update the raw input value so user sees what they type
    item.refund_qty = value;

    // Try to parse the numeric value
    const parsedQty = parseFloat(value);

    // Only update refund_amount if value is a valid number and not just "0."
    if (!isNaN(parsedQty) && value !== "0.") {
      let qty = parsedQty;

      // Clamp value
      if (qty < 0) qty = 0;
      if (qty > item.bill_qty) qty = item.bill_qty;

      if (item.uom === "EA") {
        qty = Math.floor(qty);
        item.refund_qty = qty; // For EA, coerce to integer
      } else {
        item.refund_qty = value; // For KG, keep the input string as typed
      }

      item.refund_amount = (item.bill_value * qty) / item.bill_qty;
    } else {
      item.refund_amount = 0; // Or retain previous value, your choice
    }

    setItems(updatedItems);
  };

  const handleReasonChange = (index, value) => {
    const updatedItems = [...items];
    updatedItems[index].reason = value;
    setItems(updatedItems);
  };

  return (
    <div className="flex flex-col">
      <div className="table-container">
        <div className="table-row table-header">
          <div className="table-cell cell-item">Item</div>
          <div className="table-cell cell-desc">Item Desc.</div>
          <div className="table-cell cell-qty">Qty</div>
          <div className="table-cell cell-bill">Bill Amount</div>
          <div className="table-cell cell-refund">Refund Qty</div>
          <div className="table-cell cell-amount">Refund Amount</div>
          <div className="table-cell cell-reason">Reason</div>
        </div>

        {items.map((item, index) => (
          <div className="table-row" key={index}>
            <div className="table-cell cell-item">{item.item}</div>
            <div className="table-cell cell-desc" title={item.item_desc}>
              {item.item_desc}
            </div>
            <div className="table-cell cell-qty">
              {item.bill_qty.toFixed(2)}
            </div>
            <div className="table-cell cell-bill">
              {item.bill_value.toFixed(2)}
            </div>
            <div className="table-cell cell-refund table-cell-input">
              <div className="flex border border-gray-300 rounded overflow-hidden w-full max-w-xs">
                <input
                  value={item.refund_qty}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (Number(value) > item.bill_qty) {
                      value = item.bill_qty;
                    }
                    if (item.uom === "EA") {
                      if (!/^\d*$/.test(value)) return; // Only digits
                    }

                    if (item.uom === "KG") {
                      if (!/^\d*\.?\d*$/.test(value)) return; // Allow decimal input like "0."
                    }

                    handleRefundQtyChange(index, value);
                  }}
                  min="0"
                  max={item.bill_qty}
                  // step={item.uom === "EA" ? "1" : "0.01"}
                  className="px-3 py-2 w-full focus:outline-none"
                />

                <button className="bg-gray-100 font-[800] text-[18px] px-3 py-2 border-l border-gray-300 text-gray-700 text-sm">
                  {item?.uom}
                </button>
              </div>
            </div>
            <div className="table-cell cell-amount">
              {item.refund_amount.toFixed(2)}
            </div>
            <div className="table-cell cell-reason">
              <textarea
                value={item.reason}
                onChange={(e) => handleReasonChange(index, e.target.value)}
                className="input-field"
              />
            </div>
          </div>
        ))}
      </div>

      {ssp_role !== "18" && (
        <button className="total-refund self-end">
          <strong>Total Refund Amount *:</strong> {totalRefundAmount}
        </button>
      )}
    </div>
  );
};

export default RefundTable;
